<template>
  <div
    class="eCMeterReadingCom mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftBox">
      <MultipleTree @getTreeActive="getTreeActive" />
    </div>
    <div class="rightBox">
      <div class="timeSelect">
        <el-form
          :inline="true"
          :model="formInline"
          size="mini"
          style="margin-left: 20px"
        >
          <el-form-item>
            <el-tag type="info" size="small">{{ formInline.region }}</el-tag>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              popper-class="ecReadingPicker"
              v-model="formInline.sDate"
              format="yyyy-MM-dd HH"
              value-format="yyyy-MM-dd HH"
              type="datetime"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <el-select class="minuteSelect" v-model="formInline.sMinute">
              <el-option
                v-for="item in minuteList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
            分
          </el-form-item>
          <el-form-item label="至">
            <el-date-picker
              popper-class="ecReadingPicker"
              v-model="formInline.eDate"
              format="yyyy-MM-dd HH"
              value-format="yyyy-MM-dd HH"
              type="datetime"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <el-select class="minuteSelect" v-model="formInline.eMinute">
              <el-option
                v-for="item in minuteList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
            分
          </el-form-item>
          <el-form-item style="width: 11%">
            <el-select v-model="formInline.needType">
              <el-option label="量测表" value="device"></el-option>
              <el-option label="资产" value="asset"></el-option>
              <el-option label="资产和量测表" value="all"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="
              formInline.needType == 'device' &&
              activeItemTree.activeType == 'power'
            "
          >
            <el-checkbox v-model="isTimeShare">统计峰平谷尖用电量</el-checkbox>
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="resetClick">重置</el-button>
            <el-button
              :loading="disabled"
              type="primary"
              @click="onSubmit('download')"
              plain
              v-if="judgeAuthority('nengyuan:eCMeterReading:export')"
              ><i class="el-icon-download el-icon--left"></i>
              EXCEL
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="contentBox ashComWrap">
        <div class="tableBox">
          <el-table
            :key="dynamicsIndex"
            :data="tableList"
            height="100%"
            stripe
            style="width: 100%"
            size="mini"
            :header-cell-style="{
              'font-weight': 'bold',
              color: '#333',
              'background-color': '#F7F7F7',
            }"
          >
            <el-table-column
              v-for="(v, i) in tableHead"
              :key="i"
              :prop="v.prop"
              :label="v.label"
              align="center"
            >
              <!-- <template slot-scope="scope">
                <span v-if="scope.row[v.prop] && scope.row[v.prop].length >= 8">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row[v.prop]"
                    placement="top-start"
                  >
                    <div>{{ scope.row[v.prop] }}</div>
                  </el-tooltip>
                </span>
                <span v-else>{{ scope.row[v.prop] }}</span>
              </template> -->
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[15, 30, 50]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          style="text-align: right; margin-right: 20px"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MultipleTree from "@/components/nengyuanguanli/MultipleTree";
import { dateFtt, judgeAuthority, matchingECNameUnit } from "@/assets/js/utils";
import api from "@/api";
import axios from "axios";
export default {
  components: {
    MultipleTree,
  },
  data() {
    return {
      matchType: {
        gas: "GasValue",
        water: "FlowValue",
        power: "EnergyValue",
      },
      disabled: false,
      minuteList: [],
      formInline: {
        region: "正向有功总电能",
        sDate: "",
        sMinute: "00",
        eDate: "",
        eMinute: "00",
        needType: "device",
      },
      timeData: {
        startTime: "",
        endTime: "",
      },
      paramsData: "",
      activeTree: [],
      tableList: [],
      tableHead: [],
      currentPage: 1,
      page: {
        total: null,
        size: 15,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      activeItemTree: {},
      dynamicsIndex: 0,
      isTimeShare: false,
    };
  },
  methods: {
    judgeAuthority,
    getTreeActive(data) {
      this.activeItemTree = data;
      this.activeTree = Array.from(data.name).map((item) => ({
        id: item.id,
        name: item.name,
        type: item.type,
      }));
      this.handleType();
    },
    handleType() {
      this.formInline.region =
        this.activeItemTree.activeType == "power"
          ? "正向有功总电能"
          : this.activeItemTree.activeType == "water"
          ? "市政用水"
          : this.activeItemTree.activeType == "gas"
          ? "天然气"
          : "";
    },
    getTableHeader() {
      this.tableHead = [
        {
          label:
            this.formInline.needType == "asset"
              ? "资产名称"
              : this.formInline.needType == "device"
              ? `${matchingECNameUnit(
                  this.activeItemTree.activeType,
                  "device"
                )}名称`
              : "资产/设备名称",
          prop: "name",
        },
      ];
      if (this.activeItemTree.activeType == "power") {
        this.tableHead.push(
          { label: "起始读数/kw·h", prop: "first" },
          { label: "截止读数/kw·h", prop: "last" },
          { label: "峰电/kw·h", prop: "peek" },
          { label: "平电/kw·h", prop: "flat" },
          { label: "谷电/kw·h", prop: "valley" },
          { label: "尖电/kw·h", prop: "tip" },
          { label: "总用电量/kw·h", prop: "range" }
        );
      } else {
        this.tableHead.push(
          {
            label: `起始读数/${matchingECNameUnit(
              this.activeItemTree.activeType,
              "unit"
            )}`,
            prop: "first",
          },
          {
            label: `截止读数/${matchingECNameUnit(
              this.activeItemTree.activeType,
              "unit"
            )}`,
            prop: "last",
          },
          {
            label: `总${matchingECNameUnit(
              this.activeItemTree.activeType,
              "title"
            )}量/${matchingECNameUnit(this.activeItemTree.activeType, "unit")}`,
            prop: "range",
          }
        );
      }
      if (this.formInline.needType == "asset") {
        this.tableHead = this.tableHead.filter((v) => {
          return v.prop !== "first" && v.prop !== "last";
        });
      }
    },
    onSubmit(btn) {
      for (let key in this.formInline) {
        if (!this.formInline[key]) {
          this.$message.error("请选择开始和结束时间");
          return;
        }
      }
      if (this.activeTree.length == 0) {
        this.$message.error("请选择资产");
        return;
      }
      this.timeData.startTime = new Date(
        `${this.formInline.sDate}:${this.formInline.sMinute}:00`
      ).getTime();
      this.timeData.endTime = new Date(
        `${this.formInline.eDate}:${this.formInline.eMinute}:00`
      ).getTime();
      if (this.timeData.startTime >= this.timeData.endTime) {
        this.$message.error("结束时间不能早于等于开始时间");
        return;
      }
      if (btn === "download") {
        this.disabled = true;
        this.exportFun();
      } else {
        this.getTableHeader();
        this.handleCurrentChange(1);
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    async getList() {
      this.tableList = [];
      this.dynamicsIndex++;
      this.$store.commit("SET_LOADING", true);
      let res = await api.ECMRTableData({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        pageSize: this.page.size,
        page: this.currentPage - 1,
        beginTs: this.timeData.startTime,
        endTs: this.timeData.endTime,
        data: JSON.stringify(this.activeTree),
        rangeConfig: this.matchType?.[this.activeItemTree.activeType] || "",
        label: this.activeItemTree.label,
        deviceTypes: this.activeItemTree.deviceType,
        tree: this.activeItemTree.allTreeData[0],
        type: this.activeItemTree.activeType,
        needType: this.formInline.needType,
        show24:this.isTimeShare
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableList = res.data.data.data;
        this.page.total = res.data.data.totalElements;
      }
    },
    getMinuteList() {
      for (let i = 0; i <= 55; i += 5) {
        this.minuteList.push({ value: i < 10 ? "0" + i : i });
      }
    },
    getTime() {
      let date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
      this.formInline.sDate = dateFtt("yyyy-MM-dd hh", new Date(date));
      this.formInline.eDate = dateFtt("yyyy-MM-dd hh", new Date());
    },
    resetClick() {
      this.getTime();
      this.handleType();
      this.formInline.sMinute = "00";
      this.formInline.eMinute = "00";
      this.formInline.needType = "device";
      this.isTimeShare = false;
    },
    exportFun() {
      let timer = setTimeout(() => {
        this.$message.info("文件正在下载中,请稍后!");
      }, 500);
      let parms = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        pageSize: this.page.size,
        page: this.currentPage - 1,
        beginTs: this.timeData.startTime,
        endTs: this.timeData.endTime,
        data: JSON.stringify(this.activeTree),
        rangeConfig: this.matchType?.[this.activeItemTree.activeType] || "",
        label: this.activeItemTree.label,
        deviceTypes: this.activeItemTree.deviceType,
        tree: this.activeItemTree.allTreeData[0],
        type: this.activeItemTree.activeType,
        needType: this.formInline.needType,
        needPage: false,
        show24:this.isTimeShare
      };
      let token = window.sessionStorage.getItem("token");
      let http = window.jujiParams.baseURL;
      axios({
        timeout: 6 * 60 * 1000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "X-Authorization": `Bearer ${token}`,
        },
        url: http + "/api/juji/energyConsumptionQuery/export",
        method: "post",
        responseType: "arraybuffer",
        data: parms,
      })
        .then((res) => {
          this.disabled = false;
          const decoder = new TextDecoder("utf-8");
          const str = decoder.decode(res.data);
          try {
            const result = JSON.parse(str);
            this.$message.error(result.data);
            clearTimeout(timer);
          } catch (err) {
            const url = URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.download = `${this.formInline.sDate}时${this.formInline.sMinute}分-${this.formInline.eDate}时${this.formInline.eMinute}分${this.formInline.region}.xlsx`;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          }
        })
        .catch((error) => {
          this.disabled = false;
          clearTimeout(timer);
          this.$message.error(JSON.parse(error.response).message);
        });
    },
  },
  created() {
    this.getTime();
    this.getMinuteList();
  },
};
</script>

<style scope>
.ecReadingPicker .el-time-spinner__wrapper {
  width: 100% !important;
}
</style>

<style lang="scss" scoped>
.eCMeterReadingCom {
  @include setFlexBetween;
  .leftBox {
    @include setMenuWH;
  }
  .rightBox {
    @include setCenterWH;
    .timeSelect {
      height: 60px;
      width: 100%;
      margin-bottom: 12px;
      background: #fff;
      @include setFlexStart;
      align-items: center;
      .el-form-item {
        margin-bottom: 0;
      }
      .el-input {
        width: 140px;
      }
      .minuteSelect {
        width: 75px;
      }
    }
    .contentBox {
      width: 100%;
      height: calc(100% - 72px);
      .tableBox {
        width: 98%;
        height: 88%;
        margin: 0 auto;
        padding: 20px 0;
      }
    }
  }
}
</style>
